import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ImportTemplateType } from 'src/shared/enums';

@Component({
    standalone: false,
    selector: 'app-import-footer',
    templateUrl: './import-footer.component.html',
    styleUrls: ['./import-footer.component.scss']

})
export class ImportFooterComponent {
    @Input() templateType: ImportTemplateType = ImportTemplateType.ZONE_COMBINATION_USES_VALUES;
    @Input() showValidationIcon: boolean = false;
    @Input() canImport: boolean = false;
    @Input() showValidateButton: boolean = false;

    @Output() uploadFile = new EventEmitter<void>();
    @Output() importData = new EventEmitter<void>();
    @Output() validateZoningCode = new EventEmitter<void>();
    @Output() clearTable = new EventEmitter<void>();
}
